import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import { useCrmSyncSummary } from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/crmIntegrationPage.hooks';

import type { TRaisersEdgeSyncSummaryResult } from './RaisersEdgeSyncSummary.utils';

/** The summary bar values. `undefined` until the first load settles; `null` if it failed. */
export function useRaisersEdgeSyncSummary(
  integration: BlackbaudRaisersEdgeIntegration | undefined,
  isSaving: boolean,
  pollCount: number,
): TRaisersEdgeSyncSummaryResult | undefined {
  return useCrmSyncSummary(integration, isSaving, pollCount);
}
